import { baseServiceRequest } from "../baseServiceRequest"
import type {
  IAddTraitRequest,
  IBulkAddTraitRequest,
  IBulkAddTraitResult,
  IBulkAddTraitUploadResponse,
  ITrait,
} from "./types"

export const getMemberTraits = async (
  prospect_guid: string,
): Promise<ITrait[]> => {
  const response = await baseServiceRequest({
    method: "GET",
    url: `/prospects/prospect/${prospect_guid}/traits`,
  })
  return response.data
}

export const getAllTraits = async (): Promise<ITrait[]> => {
  const response = await baseServiceRequest({
    method: "GET",
    url: `/prospects/traits`,
  })
  return response.data
}

export const addMemberTrait = async (
  data: IAddTraitRequest,
): Promise<ITrait[]> => {
  const { prospect_guid } = data

  const response = await baseServiceRequest({
    method: "POST",
    url: `/prospects/prospect/${prospect_guid}/traits`,
    data: data,
  })
  return response.data
}

export const deleteMemberTrait = async ({
  prospect_guid,
  trait_code,
}: {
  prospect_guid: string
  trait_code: string
}): Promise<ITrait[]> => {
  const response = await baseServiceRequest({
    method: "DELETE",
    url: `/prospects/prospect/${prospect_guid}/traits/${trait_code}`,
    data: null,
  })
  return response.data
}

export const bulkAddTrait = async (
  data: IBulkAddTraitRequest,
): Promise<IBulkAddTraitResult> => {
  const response = await baseServiceRequest({
    method: "POST",
    url: `/prospects/traits/bulk`,
    data,
  })
  return response.data
}

export const bulkAddTraitUpload = async (
  data: FormData,
): Promise<IBulkAddTraitUploadResponse> => {
  const response = await baseServiceRequest({
    method: "POST",
    url: `/prospects/traits/bulk_uploads`,
    data,
    // The audit interceptor spreads config.data, which empties the FormData.
    skipAuditInterceptor: true,
  })
  return response.data
}
